/* Copyright (C) Okahu Inc 2023-2024. All rights reserved. */

'use client';

import { useContext } from 'react';
import { TracesIDContext } from '@/context';

export const useTraceId = () => {
  const context = useContext(TracesIDContext);

  //   error logging incase the provider is not wrapped
  if (!context) {
    throw new Error('useTraceByID must be used within a TraceByIDProvider');
  }
  return context;
};
